import { Helmet } from "react-helmet";
import HomeSectionLayout from "../sections/homeSection/homeSectionLayout";

const LandingPage = () => {
    return (
        <>
            <Helmet>
                <title>code3x | AI, Games & Digital Solutions</title>
                <meta name="description" content="Welcome to code3x. We're your partner in AI, gaming, and digital solutions. Start your journey with us." />
                <meta name="keywords" content="code3x, AI services, game development, digital solutions, leading tech company, Sri Lanka" />
                <link rel="canonical" href="https://code3x.tech/" />
            </Helmet>

            <HomeSectionLayout />
        </>
    );
}

export default LandingPage;